firebird.controller('virtualAssistantModalCtrl', [
    '$scope',
    'helperService',
    'localizationService',
    'logService',
    'supportLinkService',
    function ($scope, helperService, localizationService, logService, supportLinkService) {
        var self = this;

        self.modalState = 'closed';
        self.shouldInitialize = true;

        self.internalLink = supportLinkService.getSupportLink('transcription');
        self.privacyPolicyLink = supportLinkService.getPrivacyPolicyLink();

        self.showEnglishVirtualAssistantText = localizationService.isEnLocale;

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);
        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);

        self.getSupportLinkUrl = getSupportLinkUrl;
        self.getPrivacyPolicyLink = getPrivacyPolicyLink;
        self.update = update;
        self.cancel = cancel;
        self.init = init;
        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;

        init();

        ////////////////////////

        function init() {
            if (helperService.getIsRedesign()) {
                //In redesign, this ctrl doesn't get initiated until it first opens,
                //So the normal event listener to detect open/close does not get triggered on first open...
                //So we call onShowModal here (the event listener will call it on subsequent open/close)
                logService.log('virtualAssistantModalCtrl init');
                self.onShowModal('show-modal', 'virtualAssistantMessage');
            }
        }

        function getSupportLinkUrl() {
            return self.internalLink;
        }

        function getPrivacyPolicyLink() {
            return self.privacyPolicyLink;
        }

        function onShowModal(e, modalName) {
            if (modalName === 'virtualAssistantMessage') {
                self.modalState = 'open';
                digest();
            }
        }

        function cancel() {}

        function update() {}

        function onHideModal(e, modalName) {
            logService.log('onHideModal ... ');

            if (modalName.indexOf('virtualAssistantModalCtrl') !== -1) {
                self.modalState = 'closed';
                digest();
            }
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'virtual-assistant';

                if (data.openedTab === tabName) {
                    logService.log('Virtual Assistant Tab opened');

                    if (self.shouldInitialize) {
                        self.shouldInitialize = false;
                        self.onShowModal('show-modal', 'virtualAssistantMessage');
                    }
                } else if (data.closedTab === tabName) {
                    logService.log('Virtual Assistant Tab closed');

                    self.onHideModal('hide-modal', 'virtualAssistantModalCtrl');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (data.applyChanges === true) {
                self.update();
            } else {
                self.cancel();
            }

            self.shouldInitialize = true;
            self.modalState = 'closed';
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
